import { useEffect, useRef, useState } from 'react';
import Peer from 'simple-peer';
import { useSocket } from '../../../providers/SocketProvider';

const CallList2 = () => {
    const [stream, setStream] = useState(null);
    const localAudio = useRef(null);
    const remoteAudio = useRef(null);
    const connectionRef = useRef(null);

    const [receiveCall, setReceiveCall] = useState(false);
    const [caller, setCaller] = useState(null);
    const [callerName, setCallerName] = useState("");
    const [callerSignal, setCallerSignal] = useState(null);
    const [callAccepted, setCallAccepted] = useState(false);
    const [callerWaiting, setCallerWaiting] = useState(false);

    const popupRef = useRef(null);
    const pos = useRef({ x: 0, y: 0 });
    const [callTime, setCallTime] = useState(0);
    const timerInterval = useRef(null);


    // 🔹 State to track microphone status
    const [isMicOn, setIsMicOn] = useState(true);

    const { socket } = useSocket();

    useEffect(() => {
        // Check if `socket` exist.
        if (!socket) {
            return; // Exit if socket is not available.
        }

        // Listen for "callToUser" event, which means another user is calling the current user.
        socket.on("incoming-call", (data) => {
            setReceiveCall(true);  // Set state to indicate an incoming call.
            setCaller(data?.visitorSocket);      // Store caller's information in state.
            setCallerName(data?.name);  // Store caller's name.
            setCallerSignal(data?.signal);  // Store WebRTC signal data for the call.
        });

        // Listen for "callEnded" event, which is triggered when the other user ends the call.
        socket.on("call-ended", (data) => {
            console.log("Call ended by - ", data); // Log the event in the console.

            endCallCleanup();  // Call a function to clean up the call state.
        });

        socket.on("call-hang", (data) => {
            console.log("Call hanged by - ", data); // Log the event in the console.

            endCallCleanup();  // Call a function to clean up the call state.
        });

        // Listen for "userBusy" event, meaning the user is already on another call.
        socket.on("incoming-call-while-busy", (data) => {
            console.log(data)
            alert(data || "User is currently in another call."); // Show an alert.
        });

        // Cleanup function: Runs when the component unmounts or dependencies change.
        return () => {
            socket.off("incoming-call");
            socket.off("call-ended");  // Remove listener for call ending.
            socket.off("incoming-call-while-busy");  // Remove listener for busy user.
        };
    }, [socket]); // Dependencies: This effect runs whenever `socket` changes.

    const handelAcceptCall = async () => {
        try {
            // ✅ Request access to the user's media devices (microphone)
            const currentStream = await navigator.mediaDevices.getUserMedia({
                video: false, // no video
                audio: {
                    echoCancellation: true, // ✅ Reduce echo in audio
                    noiseSuppression: true  // ✅ Reduce background noise
                }
            });

            // ✅ Store the stream in state so it can be used later
            setStream(currentStream);

            // ✅ Assign the stream to the local audio element for preview
            if (localAudio.current) {
                localAudio.current.srcObject = currentStream;
            }

            // ✅ Ensure that the audio track is enabled
            currentStream.getAudioTracks().forEach(track => (track.enabled = true));

            // ✅ Update call state
            setCallAccepted(true); // ✅ Mark call as accepted
            setReceiveCall(true); // ✅ Indicate that the user has received the call
            setCallerWaiting(false);//receiver join the call

            // ✅ Create a new Peer connection as the receiver (not the initiator)
            const peer = new Peer({
                initiator: false, // ✅ This user is NOT the call initiator
                trickle: false, // ✅ Prevents trickling of ICE candidates, ensuring a single signal exchange
                stream: currentStream // ✅ Attach the local media stream
            });

            // ✅ Handle the "signal" event (this occurs when the WebRTC handshake is completed)
            peer.on("signal", (data) => {
                // ✅ Emit an "call-answered" event to the server with necessary response details
                socket.emit("call-answered", {
                    signal: data, // ✅ WebRTC signal data required for establishing connection
                    // from: "visitor", // ✅ ID of the receiver (this user)
                    visitorSocket: caller
                });
            });

            // ✅ Handle the "stream" event (this is triggered when the remote user's media stream is received)
            peer.on("stream", (remoteStream) => {
                if (remoteAudio.current) {
                    remoteAudio.current.srcObject = remoteStream; // ✅ Assign remote stream to audio element
                    remoteAudio.current.muted = false; // ✅ Ensure audio from the remote user is not muted
                    remoteAudio.current.volume = 1.0; // ✅ Set volume to normal level
                }
            });

            // ✅ If there's an incoming signal (from the caller), process it
            if (callerSignal) peer.signal(callerSignal);

            // ✅ Store the peer connection reference to manage later (like ending the call)
            connectionRef.current = peer;
        } catch (error) {
            console.error("Error accessing media devices:", error); // ✅ Handle permission errors or device access failures
        }
    };

    const handelEndCall = () => {
        // ✅ Stop ringtone when call is accepted
        console.log("🔴 Sending call-ended event...");
        // ✅ Notify the other user that the call has ended
        socket.emit("call-hang", {
            targetId: caller
        });
        // ✅ Perform cleanup actions after ending the call
        endCallCleanup();
    };

    const endCallCleanup = () => {
        // ✅ Stop all media tracks (audio) to release device resources
        console.log("🔴 Stopping all media streams and resetting call...");
        clearInterval(timerInterval.current);
        setCallTime(0);
        if (stream) {
            stream.getTracks().forEach((track) => track.stop()); // ✅ Stops microphone
        }
        // ✅ Clear the receiver's audio (Remote user)
        if (remoteAudio.current) {
            console.log("🔴 Clearing receiver audio");
            remoteAudio.current.srcObject = null;
        }
        // ✅ Clear the user's own audio
        if (localAudio.current) {
            console.log("🔴 Clearing my audio");
            localAudio.current.srcObject = null;
        }
        // ✅ Destroy the peer-to-peer connection if it exists
        connectionRef.current?.destroy();
        setReceiveCall(false); // ✅ Indicate no ongoing call
        // ✅ Reset all relevant states to indicate call has ended
        setCallerWaiting(false);
        setStream(null); // ✅ Remove audio stream
        setCallAccepted(false); // ✅ Ensure call is not mistakenly marked as ongoing
        setTimeout(() => {
            window.location.reload(); // ✅ Force reset if cleanup fails
        }, 100);
    };


    // 🎤 Toggle Microphone
    const toggleMic = () => {
        if (stream) {
            const audioTrack = stream.getAudioTracks()[0];
            if (audioTrack) {
                audioTrack.enabled = !isMicOn;
                setIsMicOn(audioTrack.enabled);
            }
        }
    };

    useEffect(() => {
        if (callAccepted) {
            timerInterval.current = setInterval(() => {
                setCallTime(prev => prev + 1);
            }, 1000);
        } else {
            clearInterval(timerInterval.current);
            setCallTime(0);
        }
    }, [callAccepted]);

    const formatTime = seconds => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    };

    const handleMouseDown = e => {
        const popup = popupRef.current;
        pos.current = {
            x: e.clientX - popup.offsetLeft,
            y: e.clientY - popup.offsetTop
        };
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    const handleMouseMove = e => {
        const popup = popupRef.current;
        popup.style.left = `${e.clientX - pos.current.x}px`;
        popup.style.top = `${e.clientY - pos.current.y}px`;
    };

    const handleMouseUp = () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
    };

    return (
        <>
            {(receiveCall) && (
                <div
                    ref={popupRef}
                    onMouseDown={handleMouseDown}
                    className="fixed top-[30%] left-[35%] z-50 w-80 bg-white rounded-xl shadow-xl p-4 cursor-move"
                    style={{ position: 'absolute' }}
                >
                    <h3 className="text-lg font-bold text-gray-800">📞 Incoming Call</h3>
                    <p className="text-sm text-gray-500 mt-1">
                        {callAccepted ? 'Call in Progress' : 'Someone is calling you...'}
                    </p>
                    <audio
                        ref={localAudio}
                        autoPlay
                        controls
                        playsInline
                        muted
                        className="object-cover rounded-lg hidden"
                    />
                    <audio
                        ref={remoteAudio}
                        controls
                        autoPlay
                        className="object-contain rounded-lg hidden"
                    />
                    <div>
                        {!callAccepted ? (
                            <div className="flex justify-between mt-4">
                                <button
                                    onClick={handelAcceptCall}
                                    className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-full font-semibold"
                                >
                                    ✅ Accept
                                </button>
                                <button
                                    onClick={handelEndCall}
                                    className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-full font-semibold"
                                >
                                    ❌ Decline
                                </button>
                            </div>
                        ) : (
                            <div>
                                <p className="text-blue-600 font-semibold mt-2">⏱ Duration: {formatTime(callTime)}</p>

                                <div className="flex items-center justify-center mt-6 space-x-6">
                                    <button
                                        onClick={toggleMic}
                                        className={`w-14 h-14 rounded-full flex items-center justify-center text-white text-xl shadow-md transition ${!isMicOn ? 'bg-yellow-500 hover:bg-yellow-600' : 'bg-blue-500 hover:bg-blue-600'
                                            }`}
                                        title="Mute/Unmute"
                                    >
                                        {!isMicOn ? '🔇' : '🎤'}
                                    </button>

                                    <button
                                        onClick={handelEndCall}
                                        className="w-14 h-14 rounded-full bg-red-500 hover:bg-red-600 flex items-center justify-center text-white text-xl shadow-md transition"
                                        title="End Call"
                                    >
                                        🔴
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}

        </>
    );
};

export default CallList2;